import { useEffect } from 'react'
import Boutton from '@piconetworks/pkg-boutton'

import { useCancellation } from 'features/FeatureManager'
import { usePopup } from 'features/cartUI'
import TitleBar from 'features/cartUI/components/sections/TitleBar'
import SubmitButton from 'features/cartUI/components/sections/SubmitButton'
import PopupContainer from 'features/cartUI/components/sections/PopupContainer'

const Cancellation = ({
    app = null,
    pricingId = null,
    onCancellationStarted = (eventData = {}) => {},
    onCancellationCompleted = (eventData = {}) => {},
    onCancellationFailed = (eventData = {}) => {},
    onCancellationAborted = (eventData = {}) => {},
} = {}) => {
    const {
        setModalOpen,
        Popup,
    } = usePopup()

    const {
        cancellationStatus,
        executeCancellation,
        abortCancellation,
    } = useCancellation({
        pricingId,
        userId: app?.userId,
        publisherId: app?.publisherId,
        onCancellationStarted,
        onCancellationCompleted,
        onCancellationFailed,
        onCancellationAborted,
    })


    useEffect(() => {
        if (cancellationStatus === 'success') {
            setModalOpen(false)
        }
    },[
        cancellationStatus
    ])

    return (
        <>
            <Boutton
                onClick={() => setModalOpen(true)}
                variant="secondary"
            >
                Cancel
            </Boutton>
            <Popup
                onAfterClose={() => {
                    setModalOpen(false)
                }}
            >
            <TitleBar>Cancel subscription?</TitleBar>
                <PopupContainer>
                {/* {cancellationStatus && <div>{cancellationStatus}</div>} */}
                    <SubmitButton
                        onClick={executeCancellation}
                        variant='danger'
                    >
                        Cancel subscription
                    </SubmitButton>
                    <Boutton
                        block
                        onClick={() => {
                            abortCancellation()
                            setModalOpen(false)
                        }}
                        variant="secondary"
                    >
                        Keep subscription
                    </Boutton>
                </PopupContainer>
            </Popup>
        </>
    )
}

export default Cancellation
